/* eslint-disable */
import appUtils from './appUtils'
import html2canvas from 'html2canvas'

export const mixinPrint = {
  methods: {
    onPrintTBBHC(prtHtml, print = false) {
      // Open the print window
      const { width, height } = window.screen
      const WinPrint = window.open(
        '',
        '',
        `left=0,top=0,width=${width},height=${height},toolbar=0,scrollbars=0,status=0`
      )

      WinPrint.document.write(prtHtml)

      const el = WinPrint.document.documentElement
      // console.log(el, prtHtml)

      if (print) {
        WinPrint.focus()
        WinPrint.print()
      } else {
        WinPrint.blur()
        window.focus()
      }
      WinPrint.close()
      return el
    },
    async savePdfToS3({
      base64,
      fileName = 'DocumentFile',
      path = 'documents',
      type = 'documents',
      type_id = 'documents_id',
      uuid = ''
    }) {
      if (!base64) {
        console.log('Base64 content not found')
        return
      }

      try {
        const payload = {
          content: base64,
          fileName,
          path,
          type,
          type_id,
          uuid
        }

        const res = await this.$rf
          .getRequest('AuthRequest')
          .printDocument(payload)

        if (res?.data) {
          this.loading = false
          window.open(res.data?.documentLink, '_blank', 'noreferrer')
        }
      } catch (error) {
        console.log(error)
      }
    },
    async captureImageCanvas({ doc, dpi = 2000, scale = 10 }) {
      if (!doc || typeof doc === 'undefined') {
        console.log('Refs document print not found')
        return
      }

      try {
        const options = {
          dpi,
          scale,
          backgroundColor: '#ffffff',
          image: { type: 'jpeg', quality: 1 },
          letterRendering: true,
          allowTaint: true,
          logging: true,
          useCORS: true
        }
        const dataCanvas = await html2canvas(doc, options)
          .then((canvas) => {
            const imgBase64Data = canvas.toDataURL('image/jpeg')
            return imgBase64Data
          })
          .catch(() => { })

        return dataCanvas
      } catch (error) {
        console.log(error)
      }
    },
    async exportPdf({
      refDocument,
      fileName,
      path,
      type,
      type_id,
      uuid,
      appendStyle
    }) {
      if (!refDocument) {
        console.log('Refs document print not found')
        return
      }

      try {
        const bodyHTML = refDocument.innerHTML
        const tempHTML = this.templateHTMLPrint({ bodyHTML, appendStyle })
        const base64Data = appUtils.base64.decode(tempHTML)

        await this.savePdfToS3({
          base64: base64Data,
          fileName,
          path,
          type,
          type_id,
          uuid
        })
      } catch (error) {
        console.log(error)
      }
    },
    templateHTMLPrint({
      bodyHTML,
      title = '',
      lang = 'vi',
      appendStyle = false
    }) {
      let domain = window.location.origin
      if (domain === 'http://localhost:8081') {
        domain = 'https://dev.hodo.app'
      }
      const styleCss = `
      <link rel="stylesheet" type="text/css" href="${domain}/assets/tabler/dist/css/tabler.min.css">
      <link rel="stylesheet" type="text/css" href="${domain}/assets/css/tailwindcss.css">
      <link rel="stylesheet" type="text/css" href="${domain}/assets/css/print.css">
      <link rel="stylesheet" type="text/css" href="${domain}/assets/css/print.module.css">
      <link rel="stylesheet" type="text/css" href="https://use.fontawesome.com/releases/v5.8.1/css/all.css">
    `
      const template = `<html lang="${lang}"><head><meta charset="UTF-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1"><title>${title}</title><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Tinos:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet">${appendStyle ? styleCss : ''
        }<style>
    /* vietnamese */
    @font-face {
      font-family: "Times";
      font-weight: 700;
      src: url("${domain}/assets/font/tnr/bold.ttf");
    }
    @font-face {
      font-family: "Times";
      font-weight: 700;
      font-style: italic;
      src: url("${domain}/assets/font/tnr/bold-italic.ttf");
    }
    @font-face {
      font-family: "Times";
      font-weight: 400;
      src: url("${domain}/assets/font/tnr/regular.ttf");
    }
    @font-face {
      font-family: "Times";
      font-weight: 400;
      font-style: italic;
      src: url("${domain}/assets/font/tnr/regular-italic.ttf");
    }
    html, body {
      font-family: "Times New Roman", "Times", "Tinos", serif !important;
      font-size: 1.0625rem;
      line-height: 1.5rem;
      font-weight: 500;
      font-style: normal;
      letter-spacing: 0em;
      color: #000000 !important;
    }
    #wrapper {overflow-x: hidden;}@font-face {font-family: "Times";font-weight: 700;src: url("${domain}/assets/font/tnr/bold.ttf");}@font-face {font-family: "Times";font-weight: 700;font-style: italic;src: url("${domain}/assets/font/tnr/bold-italic.ttf");}@font-face {font-family: "Times";font-weight: 400;src: url("${domain}/assets/font/tnr/regular.ttf");}@font-face {font-family: "Times";font-weight: 400;font-style: italic;src: url("${domain}/assets/font/tnr/regular-italic.ttf");}@import url("https://fonts.googleapis.com/css2?family=Tinos:ital,wght@0,400;0,700;1,400;1,700&display=swap");#ElementToPrint, #ElementToPrint *:not([class*=" el-icon-"], [class^="el-icon-"]), #ElementToPrint p, #ElementToPrint span {font-family: "Times New Roman", "Times", "Tinos", serif !important;color: black;}#ElementToPrint {}#CareDetail, #CareDetail i, #CareDetail ul, #CareDetail li, #CareDetail p, #CareDetail strong, #phieuPhauThuatViewDetail, #phieuPhauThuatViewDetail p, #phieuPhauThuatViewDetail strong, #phieuPhauThuatViewDetail i, #PhieuGayMeViewDetail, #PhieuGayMeViewDetail p, #PhieuGayMeViewDetail strong, #PhieuGayMeViewDetail i, #PhieuChamSocViewDetail, #PhieuChamSocViewDetail p, #PhieuChamSocViewDetail strong, #PhieuChamSocViewDetail span {color: black;margin: 0;font-family: "Times New Roman", "Times", "Tinos", serif !important;}#CareDetail, #CareDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #phieuPhauThuatViewDetail, #phieuPhauThuatViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #PhieuGayMeViewDetail, #PhieuGayMeViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #PhieuChamSocViewDetail, #PhieuChamSocViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #TempPhieuChucNangSong, #TempPhieuChucNangSong *:not([class*=" el-icon-"], [class^="el-icon-"]) {color: black;font-family: "Times New Roman", "Times", "Tinos", serif !important;}#TemplatePrescription, #TemplatePrescription *:not([class*=" el-icon-"], [class^="el-icon-"]), #TemplatePrescription p, #TemplatePrescription div, #TemplatePrescription span, #MedicalRecordsViewDetail, #MedicalRecordsViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #MedicalRecordsViewDetail p, #MedicalRecordsViewDetail label, #MedicalRecordsViewDetail div, #MedicalRecordsViewDetail span, #MedicalRecordsViewDetail strong, #MedicalRecordsViewDetail i, #tmpPhieuGayMe, #tmpPhieuGayMe *:not([class*=" el-icon-"], [class^="el-icon-"]), #tmpPhieuGayMe p, #tmpPhieuGayMe div, #tmpPhieuGayMe span, #tmpPhieuGayMe p, #tmpPhieuGayMe label, #tmpPhieuGayMe div, #tmpPhieuGayMe span, #tmpPhieuGayMe strong, #tmpPhieuGayMe i, #modalPhieuGayMe, #modalPhieuGayMe *:not([class*=" el-icon-"], [class^="el-icon-"]), #modalPhieuGayMe p, #modalPhieuGayMe div, #modalPhieuGayMe span, #modalPhieuGayMe p, #modalPhieuGayMe label, #modalPhieuGayMe div, #modalPhieuGayMe span, #modalPhieuGayMe strong, #modalPhieuGayMe i, #TreatmentViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #TreatmentViewDetail div, #TreatSumsViewDetail div, #TreatmentViewDetail span, #TreatSumsViewDetail span, #CareDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #CareDetail div, #CareDetail span, #bienbantemp, #bienbantemp *:not([class*=" el-icon-"], [class^="el-icon-"]), #bienbantemp div, #bienbantemp span, #bienbantemp strong, #bienbantemp i, #meetConcludingTemp, #meetConcludingTemp *:not([class*=" el-icon-"], [class^="el-icon-"]), #meetConcludingTemp p, #meetConcludingTemp div, #meetConcludingTemp span, #meetConcludingTemp strong, #meetConcludingTemp i, #TTTQMTemp, #TTTQMTemp *:not([class*=" el-icon-"], [class^="el-icon-"]), #TTTQMTemp p, #TTTQMTemp div, #TTTQMTemp span, #TTTQMTemp strong, #TTTQMTemp i, #IndicationsPrinter, #IndicationsPrinter *:not([class*=" el-icon-"], [class^="el-icon-"]), #IndicationsPrinter div, #IndicationsPrinter span, #IndicationsPrinter i, #IndicationResultPrintTemplate, #IndicationResultPrintTemplate *:not([class*=" el-icon-"], [class^="el-icon-"]), #IndicationResultPrintTemplate p, #IndicationResultPrintTemplate div, #IndicationResultPrintTemplate b, #IndicationResultPrintTemplate i, #IndicationResultPrintTemplate h1, #IndicationResultPrintTemplate h2, #IndicationResultPrintTemplate h3, #IndicationResultPrintTemplate h4, #IndicationResultPrintTemplate h5, #IndicationResultPrintTemplate h6, #IndicationResultPrintTemplate span, #IndicationResultPrintTemplate strong, #TemplateViewGMTM, #TemplateViewGMTM *:not([class*=" el-icon-"], [class^="el-icon-"]), #TemplateViewGMTM p, #TemplateViewGMTM div, #TemplateViewGMTM b, #TemplateViewGMTM i, #TemplateViewGMTM h1, #TemplateViewGMTM h2, #TemplateViewGMTM h3, #TemplateViewGMTM h4, #TemplateViewGMTM h5, #TemplateViewGMTM h6, #TemplateViewGMTM span, #TemplateViewGMTM strong, #PhieuGayMeViewDetail, #PhieuGayMeViewDetail *:not([class*=" el-icon-"], [class^="el-icon-"]), #TempPhieuChucNangSong, #TempPhieuChucNangSong *:not([class*=" el-icon-"], [class^="el-icon-"]) {font-family: "Times New Roman", "Times", "Tinos", serif !important;}#bienbantemp .content-box, #meetConcludingTemp .content-box, #bienbantemp .content-box p, #meetConcludingTemp .content-box p {font-family: "Times New Roman", "Times", "Tinos", serif !important;font-size: 12px;margin-bottom: 0px;}.content-box, .content-box p, .content-box b, .content-box div, .content-box span, .content-box i, .content-box strong {font-family: "Times New Roman", "Times", "Tinos", serif !important;font-size: 12px;margin-bottom: 0px;}.content-box-10i, .content-box-10i p, .content-box-10i b, .content-box-10i div, .content-box-10i span, .content-box-10i i, .content-box-10i strong {font-family: "Times New Roman", "Times", "Tinos", serif !important;font-size: 10px;margin-bottom: 0px;font-style: italic;}.ck-editor__editable {min-height: 200px;}@media (min-width: 768px) {#page-content-wrapper {min-width: 0;}}.v-toast {z-index: 2011 !important;}.v-toast__item {padding: 5px;justify-content: flex-start;box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);}.v-toast__item--default .v-toast__icon {display: block;width: 64px !important;min-width: 64px !important;height: 64px !important;margin-left: 1em;background: url(../../hodologo_256x256.png) no-repeat !important;background-size: 64px 64px !important;}.v-toast__item--default {background-color: #fff !important;}.v-toast__item--default .v-toast__text {font-family: "Roboto" !important;color: black !important;}.mw-135px {min-width: 135px;}.btn-circle {width: 40px;height: 40px;text-align: center;padding: 0;font-size: 20px;line-height: 40px;border-radius: 20px !important;}.notification-tab {min-width: 200px;}.notification-link {color: #232e3c !important;}.notification-link:hover {text-decoration: none;}.notification-link:hover .row {background: #e3e3e3 !important;border-radius: 5px;}.notification-side {top: 0;bottom: 0;position: fixed;overflow-y: scroll;overflow-x: hidden;width: 300px;right: 0;background-color: #f4f6fa;z-index: 1032;}.notification-side::-webkit-scrollbar {width: 5px;height: 10px;}.notification-side::-webkit-scrollbar-thumb {border-radius: 8px;background-color: #c2c9d2;}.bg-drop {z-index: 1031;width: 100vw;height: 100vh;position: fixed;opacity: 0.5;}.btn {font-weight: 400 !important;}#conversation .ck-editor__editable_inline:focus {color: black;}#conversation .ck-editor__editable_inline {max-height: 120px;line-height: 23px;overflow: auto;min-height: 50px;border-left: none !important;border-right: none !important;}#conversation .ck-toolbar_grouping, #conversation .ck.ck-toolbar__items {border: none !important;background: white;}#ElectronicMedicalRecords .ck-editor__editable_inline {line-height: 24px;overflow: auto;min-height: 64px;}#ElectronicMedicalRecords .ck-toolbar_grouping > .ck-toolbar__items {height: 30px;}#ElectronicMedicalRecords .ck-toolbar_grouping > .ck-toolbar__items > button {min-height: 20px !important;min-width: 20px !important;padding: 0;margin: 0 8px;}#ElectronicMedicalRecords .ck-toolbar__items > .ck-toolbar-dropdown {margin: 0 8px;}#ElectronicMedicalRecords .ck-toolbar__items .ck-dropdown__arrow {height: 12px;width: 12px;}#ElectronicMedicalRecords .ck-toolbar__items .ck-dropdown__button .ck-splitbutton__arrow svg {height: 12px;width: 12px;}#ElectronicMedicalRecords .ck-sticky-panel button > svg {height: 16px;width: 16px;}#ElectronicMedicalRecords .ck-dropdown__panel-visible button > svg {height: 44px;width: 44px;}#ElectronicMedicalRecords .ck-dropdown__panel-visible .ck-toolbar_vertical svg {height: 16px;width: 16px;}.toast-push-notify {max-height: 100px;overflow: hidden;}#tagInputSpcl .tags-input-badge {border-radius: 8px;font-weight: 500;font-size: 14px;padding: 9px 25px 9px 10px;background-color: #e7eaf5;margin: 2px 16px 2px 0px;}#tagRemove .tags-input-remove {font-size: 20px;}#tagRemove .tags-input-remove:after {background: #292d32;}#tagRemove .tags-input-remove:before {background: #292d32;}.form--input {border-radius: 4px;border: none;background-color: #f6f8fb;line-height: 32px;font-size: 14px;font-weight: 500;color: #1d2939;width: 100%;padding: 0 8px;}.el-input__inner {border-radius: 4px !important;border: none !important;background-color: #f6f8fb !important;line-height: 32px !important;font-size: 14px !important;font-weight: 500 !important;color: #1d2939 !important;}.el-input__prefix, .el-input__suffix {color: #1d2939 !important;}.el-date-editor.el-input, .el-date-editor.el-input__inner {width: 100% !important;}.form--input::-webkit-input-placeholder {font-size: 14px;font-weight: 400;}.form--input:-ms-input-placeholder {font-size: 14px;font-weight: 400;}.form--input::placeholder {font-size: 14px;font-weight: 400;}input[type="radio"] {width: 1rem;height: 1rem;}.form--input:focus-visible {outline: solid 1px #20419b !important;}.v-html-p-0 p {margin-bottom: 0 !important;}#TemplatePrescription, #MedicalRecordsExport, #TreatmentViewDetail, #TreatSumsViewDetail, #phieuPhauThuatViewDetail, #PhieuGayMeViewDetail, #PhieuChamSocViewDetail, #CareDetail {}#MedicalRecordsViewDetail .h-detail2 {height: calc(100vh - 11rem);}#MedicalRecordsViewDetail input[type="radio"] {display: none;}#MedicalRecordsViewDetail .border-box {border: 1px solid;}#MedicalRecordsViewDetail .border-bottom-item {border-bottom: 1px solid;}#MedicalRecordsViewDetail .border-right-item {border-right: 1px solid;}#MedicalRecordsViewDetail .box-h-item {min-height: 24px;min-width: 24px;}#MedicalRecordsViewDetail .content-none {width: 80%;border-bottom: 2px dotted;margin-bottom: 6px;}#MedicalRecordsViewDetail .min-h-20 {min-height: 5rem;}th div, td div {word-break: inherit !important;}.el-date-editor .el-range-separator {width: auto !important;}.el-date-editor--daterange {background-color: #fff !important;border-radius: 4px !important;border: 1px solid #dcdfe6 !important;box-sizing: border-box !important;color: #606266 !important;display: inline-block !important;font-size: inherit !important;height: 40px !important;line-height: 40px !important;outline: 0 !important;padding: 0 15px !important;transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;width: 100% !important;}.el-range-editor .el-range-input {background-color: initial;}.el-table__cell div {word-break: break-word !important;}.el-dialog__headerbtn .el-dialog__close {color: #000 !important;font-size: 22px !important;}
    .hidden-on-pdf {
      display: none !important;
    }
    .hodo-print,
    .hodo-print * {
      font-family: "Times New Roman", "Times", "Tinos", serif !important;
      letter-spacing: 0em;
      color: #000000 !important;
    }
    .hodo-print img {
      max-width: 100%;
    }
    .hodo-print img,
    .hodo-print svg {
      vertical-align: middle;
    }
    .hodo-print .content-none {
      width: 100%;
      border-bottom: 2px dotted;
    }
    .hodo-print .font {
      font-family: "Times New Roman", Tinos, Times, serif !important;
    }
    .hodo-print p {
      margin: 0;
    }
    .hodo-print .text-italic {
      font-style: italic;
    }
    .hodo-print .px-8 {
      padding-right: 2rem;
      padding-left: 2rem;
    }
    .hodo-print .overflow-hidden {
      overflow: hidden;
    }
    .hodo-print .float-left {
      float: left;
    }
    .hodo-print .float-right {
      float: right;
    }
    .hodo-print .float-none {
      float: none;
    }
    .hodo-print .block {
      display: block;
    }
    .hodo-print .hidden {
      display: none;
    }
    .hodo-print .inline-block {
      display: inline-block !important;
    }
    .hodo-print .flex {
      display: flex;
    }
    .hodo-print .flex-col {
      flex-direction: column;
    }
    .hodo-print .align-top {
      vertical-align: top;
    }
    .hodo-print .text-center {
      text-align: center;
    }
    .hodo-print .text-left {
      text-align: left;
    }
    .hodo-print .text-right {
      text-align: right;
    }
    .hodo-print .normal-case {
      text-transform: none;
    }
    .hodo-print .uppercase {
      text-transform: uppercase;
    }
    .hodo-print .capitalize {
      text-transform: capitalize;
    }
    .hodo-print .leading-none {
      line-height: 1;
    }
    .hodo-print .align-middle {
      vertical-align: middle;
    }
    .hodo-print .justify-center {
      justify-content: center;
    }
    .hodo-print .justify-end {
      justify-content: end;
    }
    .hodo-print .justify-between {
      justify-content: space-between;
    }
    .hodo-print .items-start {
      align-items: flex-start;
    }
    .hodo-print .items-center {
      align-items: center;
    }
    .hodo-print .col-1 {
      width: 12% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-2 {
      width: 16.6666667% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-3 {
      width: 25% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-4 {
      width: 33.3333333% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-5 {
      width: 41% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-6 {
      width: 50% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-7 {
      width: 58.3333333% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-8 {
      width: 66.666666% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .col-12 {
      width: 100% !important;
      display: inline-block !important;
      vertical-align: top;
    }
    .hodo-print .w-full {
      width: 100% !important;
    }
    .hodo-print .w-half {
      width: 50% !important;
    }
    .hodo-print .w-one-third {
      width: 33.333% !important;
    }
    .hodo-print .w-two-thirds {
      width: 66.667% !important;
    }
    .hodo-print .font-normal {
      font-weight: 400;
    }
    .hodo-print .font-bold {
      font-weight: 700;
    }
    .hodo-print .fs-11,
    .hodo-print .fs-11 *,
    .hodo-print .content-size.fs-11,
    .hodo-print .content-size.fs-11 * {
      font-size: 0.6125rem;
      line-height: 0.75rem;
    }
    .hodo-print .text-xs,
    .hodo-print .text-xs *,
    .hodo-print .fs-12,
    .hodo-print .fs-12 *,
    .hodo-print .content-size.fs-12,
    .hodo-print .content-size.fs-12 * {
      font-size: 0.75rem;
      line-height: 1rem;
    }
    .hodo-print .fs-13,
    .hodo-print .fs-13 *,
    .hodo-print .content-size.fs-13,
    .hodo-print .content-size.fs-13 * {
      font-size: 0.8125rem;
      line-height: 1.25rem;
    }
    .hodo-print .fs-14,
    .hodo-print .fs-14 *,
    .hodo-print .content-size.fs-14,
    .hodo-print .content-size.fs-14 * {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .hodo-print .fs-15,
    .hodo-print .fs-15 *,
    .hodo-print .content-size.fs-15,
    .hodo-print .content-size.fs-15 * {
      font-size: 0.9375rem;
      line-height: 1.25rem;
    }
    .hodo-print .text-sm,
    .hodo-print .text-sm * .hodo-print .fs-16,
    .hodo-print .fs-16 *,
    .hodo-print .content-size.fs-16,
    .hodo-print .content-size.fs-16 * {
      font-size: 1rem;
      line-height: 1.25rem;
    }
    .hodo-print .text-base,
    .hodo-print .text-base * {
      font-size: 1rem;
      line-height: 1.5rem;
    }
    .hodo-print .fs-17,
    .hodo-print .fs-17 *,
    .hodo-print .content-size.fs-17,
    .hodo-print .content-size.fs-17 * {
      font-size: 1.0625rem;
      line-height: 1.5rem;
    }
    .hodo-print .text-lg,
    .hodo-print .text-lg *,
    .hodo-print .fs-18,
    .hodo-print .fs-18 *,
    .hodo-print .content-size.fs-18,
    .hodo-print .content-size.fs-18 * {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
    .hodo-print .fs-19,
    .hodo-print .fs-19 *,
    .hodo-print .content-size.fs-19,
    .hodo-print .content-size.fs-19 * {
      font-size: 1.1875rem;
      line-height: 1.75rem;
    }
    .hodo-print .text-xl,
    .hodo-print .text-xl *,
    .hodo-print .fs-20,
    .hodo-print .fs-20 *,
    .hodo-print .content-size.fs-20,
    .hodo-print .content-size.fs-20 * {
      font-size: 1.25rem;
      line-height: 1.75rem;
    }
    .hodo-print .fs-22,
    .hodo-print .fs-22 *,
    .hodo-print .content-size.fs-22,
    .hodo-print .content-size.fs-22 * {
      font-size: 1.375rem;
      line-height: 1.825rem;
    }
    .hodo-print .text-2xl,
    .hodo-print .text-2xl *,
    .hodo-print .fs-24,
    .hodo-print .fs-24 *,
    .hodo-print .content-size.fs-24,
    .hodo-print .content-size.fs-24 * {
      font-size: 1.5rem;
      line-height: 2rem;
    }
    .hodo-print .my-3 {
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;
    }
    .hodo-print .px-1 {
      padding-left: 0.25rem;
      padding-right: 0.25rem;
    }
    .hodo-print .px-24 {
      padding-left: 6rem !important;
      padding-right: 6rem !important;
    }
    .hodo-print .py-0 {
      padding-top: 0;
      padding-bottom: 0;
    }
    .hodo-print .py-1 {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    .hodo-print .pt-12 {
      padding-top: 3rem;
    }
    .hodo-print .p-0 {
      padding: 0;
    }
    .hodo-print .p-1 {
      padding: 0.25rem;
    }
    .hodo-print .p-2 {
      padding: 0.5rem;
    }
    .hodo-print .pt-1 {
      padding-top: 0.25rem;
    }
    .hodo-print .pb-1 {
      padding-bottom: 0.25rem;
    }
    .hodo-print .pb-2 {
      padding-bottom: 0.5rem;
    }
    .hodo-print .pb-20 {
      padding-bottom: 5rem;
    }
    .hodo-print .pl-0 {
      padding-top: 0;
    }
    .hodo-print .pl-0\.5 {
      padding-left: 0.125rem;
    }
    .hodo-print .pl-2 {
      padding-left: 0.5rem;
    }
    .hodo-print .pt-3 {
      padding-top: 0.75rem;
    }
    .hodo-print .pl-3 {
      padding-left: 0.75rem !important;
    }
    .hodo-print .pl-12 {
      padding-left: 3rem;
    }
    .hodo-print .pl-16 {
      padding-left: 4rem;
    }
    .hodo-print .pl-1 {
      padding-left: 0.25rem;
    }
    .hodo-print .pr-0 {
      padding-right: 0;
    }
    .hodo-print .pr-12 {
      padding-right: 3rem;
    }
    .hodo-print .pr-16 {
      padding-right: 4rem;
    }
    .hodo-print .pr-20 {
      padding-right: 5rem;
    }
    .hodo-print .-mt-1 {
      margin-top: -0.25rem;
    }
    .hodo-print .mt-1 {
      margin-top: 0.25rem;
    }
    .hodo-print .mt-2 {
      margin-top: 0.5rem;
    }
    .hodo-print .mt-3 {
      margin-top: 0.75rem;
    }
    .hodo-print .mt-4 {
      margin-top: 1rem;
    }
    .hodo-print .m-6 {
      margin: 1.5rem;
    }
    .hodo-print .ml-6 {
      margin-left: 1.5rem;
    }
    .hodo-print .mt-6 {
      margin-top: 1.5rem;
    }
    .hodo-print .mt-8 {
      margin-top: 2rem;
    }
    .hodo-print .mt-10 {
      margin-top: 2.5rem;
    }
    .hodo-print .mt-12 {
      margin-top: 3rem;
    }
    .hodo-print .mt-16 {
      margin-top: 4rem;
    }
    .hodo-print .mb-16 {
      margin-bottom: 4rem;
    }
    .hodo-print .mt-20 {
      margin-top: 5rem;
    }
    .hodo-print .mt-24 {
      margin-top: 6rem;
    }
    .hodo-print .mt-44 {
      margin-top: 11rem;
    }
    .hodo-print .ml-auto {
      margin-left: auto;
    }
    .hodo-print .-ml-0\.25 {
      margin-left: -1.5px;
    }
    .hodo-print .mx-1 {
      margin-left: 0.25rem;
      margin-right: 0.25rem;
    }
    .hodo-print .ml-1 {
      margin-left: 0.25rem;
    }
    .hodo-print .ml-2 {
      margin-left: 0.5rem;
    }
    .hodo-print .ml-3 {
      margin-left: 0.75rem;
    }
    .hodo-print .ml-3\.5 {
      margin-left: 0.875rem;
    }
    .hodo-print .ml-4 {
      margin-left: 1rem;
    }
    .hodo-print .ml-5 {
      margin-left: 1.25rem;
    }
    .hodo-print .ml-24 {
      margin-left: 6rem;
    }
    .hodo-print .mr-0\.25 {
      margin-right: 1.5px;
    }
    .hodo-print .mr-1 {
      margin-right: 0.25rem;
    }
    .hodo-print .mr-3 {
      margin-right: 0.75rem;
    }
    .hodo-print .mb-0 {
      margin-bottom: 0;
    }
    .hodo-print .mb-0\.5 {
      margin-bottom: 0.125rem;
    }
    .hodo-print .mb-1 {
      margin-bottom: 0.25rem;
    }
    .hodo-print .mb-2 {
      margin-bottom: 0.5rem;
    }
    .hodo-print .mb-3 {
      margin-bottom: 0.75rem;
    }
    .hodo-print .mb-6 {
      margin-bottom: 1.5rem;
    }
    .hodo-print .mb-8 {
      margin-bottom: 2rem;
    }
    .hodo-print .hodo-table figure {
      margin: 0 0 1rem !important;
    }
    .hodo-print .hodo-table table {
      border-collapse: collapse !important;
      width: 100% !important;
      border: 1px solid #7d7d7e !important;
      margin-top: 1rem !important;
    }
    .hodo-print .hodo-table.border-black table {
      border-color: black !important;
    }
    .hodo-print .hodo-table table thead th {
      text-transform: uppercase !important;
    }
    .hodo-print .hodo-table table td,
    .hodo-print .hodo-table table th {
      padding: 8px !important;
      border: 1px solid #7d7d7e !important;
    }
    .hodo-print .hodo-table.border-black table td,
    .hodo-print .hodo-table.border-black table th {
      border-color: black !important;
    }

    .hodo-print .hodo-table table td p {
      min-height: 25px !important;
    }
    .hodo-table-cs tbody tr:nth-child(2) td:first-child {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .hodo-table-cs tbody tr:nth-child(2) td:first-child p {
      margin-bottom:4px
    }

    .hodo-table-cs tbody tr:nth-child(2) td:nth-child(2) p,
    .hodo-table-cs tbody tr:nth-child(2) td:nth-child(3) p {
      min-height: 35px !important;
      min-width: 45px !important;
    }


    .hodo-print .table-width-full table {
      width: 100% !important;
    }
    .hodo-print .el-table--border,
    .hodo-print .el-table--group {
      border-top: 1px solid #000;
      border-right: 1px solid #000;
      border-left: 1px solid #000;
    }
    .hodo-print .el-table th.el-table__cell.is-leaf {
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
    .hodo-print .el-table__row:last-child,
    .hodo-print .el-table__cell:last-child,
    .hodo-print .el-table th.el-table__cell.is-leaf:last-child {
      border-right: none;
    }
    .hodo-print .el-table__cell {
      border-bottom: 1px solid #000;
      border-right: 1px solid #000;
    }
    .hodo-print .el-table--border th.el-table__cell > div.cell {
      line-height: 1.25 !important;
    }
    .hodo-print thead th.padding-header {
      padding: 0 8px !important;
    }
    .hodo-print thead th.header-text-left {
      text-align: left !important;
      padding: 0 8px !important;
    }
    .hodo-print .break-words {
      overflow-wrap: break-word !important;
      word-break: break-word !important;
      word-wrap: break-word !important;
      white-space: break-spaces !important;
    }
    .hodo-print .border-box {
      border: 1px solid #000;
    }
    .hodo-print .border {
      border: 1px solid #e0e0e0 !important;
    }
    .hodo-print .border-t {
      border-top: 1px solid #000;
    }
    .hodo-print .border-b {
      border-bottom: 1px solid #000;
    }
    .hodo-print .border-b-cs {
      border-bottom: 1px solid #7d7d7e;
    }
    .hodo-print .border-l {
      border-left: 1px solid #000;
    }
    .hodo-print .border-r {
      border-right: 1px solid #000;
    }
    .relative {
      position: relative;
    }
    .absolute {
      position: absolute;
    }
    .top-0 {
      top: 0;
    }
    .right-0 {
      right: 0;
    }
    .bottom-0 {
      bottom: 0;
    }
    .left-0 {
      left: 0;
    }
    .whitespace-nowrap {
      white-space: nowrap;
    }
    .overflow-hidden {
      overflow: hidden;
    }
    .float-left {
      float: left;
    }
    .float-right {
      float: right;
    }
    .float-none {
      float: none;
    }
    .block {
      display: block;
    }
    .inline-block {
      display: inline-block;
    }
    .flex {
      display: flex;
    }
    .flex-col {
      flex-direction: column;
    }
    .align-top {
      vertical-align: top;
    }
    .text-center {
      text-align: center;
    }
    .text-left {
      text-align: left;
    }
    .text-right {
      text-align: right;
    }
    .normal-case {
      text-transform: none;
    }
    .uppercase {
      text-transform: uppercase;
    }
    .capitalize {
      text-transform: capitalize;
    }
    .leading-none {
      line-height: 1;
    }
    .align-middle {
      vertical-align: middle;
    }
    .justify-center {
      justify-content: center;
    }
    .justify-end {
      justify-content: end;
    }
    .justify-between {
      justify-content: space-between;
    }
    .items-start {
      align-items: flex-start;
    }
    .items-center {
      align-items: center;
    }
    .box-number {
      border: 1px solid black;
      height: 1.5rem !important;
    }
    .box-item {
      font-family: "Times New Roman", Tinos, Times, serif !important;
      height: 1.5rem !important;
      width: 1.5rem !important;
      border-right: 1px solid black;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .box-item-bhyt {
      font-family: "Times New Roman", Tinos, Times, serif !important;
      height: 1.5rem !important;
      min-width: 1.5rem !important;
      width: 100%;
      padding: 2px;
      border-right: 1px solid black;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .box-item-bhyt:last-child,
    .box-item:last-child {
      border-right: none;
    }
    .checkbox {
      display: inline-flex;
      cursor: pointer;
      position: relative;
    }
    .html2pdf__page-break {
      page-break-before: always;
    }
    .italic {
      font-style: italic;
    }
    .not-italic {
      font-style: normal;
    }
    .w-3 {
      width: 0.75rem;
    }
    .h-3 {
      height: 0.75rem;
    }
    .w-24 {
      width: 6rem;
    }
    .h-24 {
      height: 6rem;
    }
    .w-40 {
      width: 10rem;
    }
    .h-40 {
      height: 10rem;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .cursor-default {
      cursor: default;
    }
    .min-h-250 {
      min-height: 250px;
    }
    .min-h-350 {
      min-height: 350px;
    }
    .hodo-print .border-box-table {
      border-top: 1px solid black;
      border-left: 1px solid black;
    }
    .hodo-print .border-bottom-item-table {
      border-bottom: 1px solid black;
    }
   .hodo-print .border-right-item-table {
      border-right: 1px solid black;
    }
    .hodo-print .box-nv {
      position: relative;
      border: 1px solid black;
      margin-top: 4px;
    }

    .hodo-print .el-icon-close {
      position: absolute;
      right: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 0.75rem;
      height: 0.75rem;
      opacity: 1;
    }
    .hodo-print .el-icon-close:before, .el-icon-close:after {
      position: absolute;
      left: 1.1rem;
      content: ' ';
      height: 0.75rem;
      width: 2px;
      background-color: #333;
    }
    .hodo-print .el-icon-close:before {
      transform: rotate(45deg);
    }
    .hodo-print .el-icon-close:after {
      transform: rotate(-45deg);
    }x
    .hodo-print .el-center {
      position: absolute;
      content: "";
      right: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .hodo-print .w-fit{
      width: fit-content;
    }
    .hodo-print .flex-1{
      flex: 1;
    }

    .hodo-print .ql-syntax {
      background-color: #23241f;
      color: #f8f8f2;
      overflow: visible;
    }

    .hodo-print .ql-align-center{
      text-align: center;
    }

    .hodo-print .ql-align-right{
      text-align: right;
    }

    .hodo-print .ql-align-left{
      text-align: left;
    }

    .object-contain{
      object-fit: contain;
    }

    .hodo-print .mx-auto {
      margin-left: auto;
      margin-right: auto;
    }

    .hodo-print .content-none-cs{
      margin-bottom: 0.25rem;
    }

    #phieukham *{
      font-size:20px
    }

    #phieukham h1 *{
      font-size:28px !important
     }

     #phieukham h1{
        margin-bottom:30px !important;
        display:block !important
     }

     #phieukham p{
      margin-bottom:12px
     }
     #phieukham table{
      width:100% !important
     }

     #phieukham tbody{
       width:100% !important
      }

     #phieukham tr{
      display:block !important;
      width:100% !important;
      min-height:90px
     }

     #phieukham td:first-child p *{
      font-size:16px !important;
     }

     #phieukham td:first-child p{
      margin-bottom:0 !important;
     }

     #phieukham td:first-child{
      width:250px !important
     }

     #phieukham td:nth-child(2) p{
       margin-bottom:0 !important;
      }
      #phieukham td:nth-child(2) p *{
        font-size:18px !important;
      }
      #phieukham td:nth-child(2){
       margin-right:0px !important;
       display:block !important;
       width:650px !important;
      }
      #phieukham td:nth-child(3){
        vertical-align:top;
        width:240px !important;
      }
      #phieukham td:nth-child(3) * {
        font-size:18px !important;
        display:block;
        width:100%;
        height:100%;
       }

       #phieukham td:nth-child(3) p:first-child {
          margin-bottom:0 !important
       }

       #phieukham td:nth-child(3) p:last-child *{
          font-size:22px !important
      }

    </style></head><body>${bodyHTML}</body></html>`
      return template
    },
  },
}

